import React, { useState } from 'react';
import CustomInput from '../components/custom_input/customInput';
import CustomButton from '../components/custom_button/customButton';
import ApiService from '../api_services/apiService.jsx';
import { ReactComponent as SettingsIcon } from '../icons/settings.svg';
import './ProfileSettingsModals.css';

const SettingsModal = ({ onClose }) => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    const handleClose = () => {
        setOldPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setError('');
        setSuccess('');
        onClose();
    };

    const handleSave = async () => {
        setError('');
        setSuccess('');

        if (!oldPassword || !newPassword || !confirmPassword) {
            setError('Uzupełnij wszystkie pola.');
            return;
        }

        if (newPassword !== confirmPassword) {
            setError('Nowe hasła nie są identyczne.');
            return;
        }

        try {
            setIsSaving(true);
            await ApiService.changePasswordWithOld(oldPassword, newPassword);
            setSuccess('Hasło zostało zmienione.');
            setOldPassword('');
            setNewPassword('');
            setConfirmPassword('');
        } catch (err) {
            console.error('Błąd zmiany hasła:', err);
            setError('Nie udało się zmienić hasła.');
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="mapen-modal-overlay">
            <div className="mapen-modal">
                <div className="mapen-modal-header">
                    <h3 className="mapen-modal-title">
                        <SettingsIcon />
                        Ustawienia profilu
                    </h3>
                    <button className="mapen-modal-close" onClick={handleClose} aria-label="Zamknij">
                        &times;
                    </button>
                </div>
                <div className="mapen-modal-body">
                    <div className="mapen-modal-field">
                        <span className="mapen-modal-label">Stare hasło</span>
                        <CustomInput
                            placeholder="Wpisz stare hasło"
                            value={oldPassword}
                            onChange={(event) => setOldPassword(event.target.value)}
                            type="password"
                            autoComplete="current-password"
                            baseClass="custom-input mapen-modal-input"
                        />
                    </div>
                    <div className="mapen-modal-field">
                        <span className="mapen-modal-label">Nowe hasło</span>
                        <CustomInput
                            placeholder="Wpisz nowe hasło"
                            value={newPassword}
                            onChange={(event) => setNewPassword(event.target.value)}
                            type="password"
                            autoComplete="new-password"
                            baseClass="custom-input mapen-modal-input"
                        />
                    </div>
                    <div className="mapen-modal-field">
                        <span className="mapen-modal-label">Powtórz nowe hasło</span>
                        <CustomInput
                            placeholder="Powtórz nowe hasło"
                            value={confirmPassword}
                            onChange={(event) => setConfirmPassword(event.target.value)}
                            type="password"
                            autoComplete="new-password"
                            baseClass="custom-input mapen-modal-input"
                        />
                    </div>

                    {error && <div className="mapen-modal-feedback error">{error}</div>}
                    {success && <div className="mapen-modal-feedback success">{success}</div>}

                    <div className="mapen-modal-actions">
                        <CustomButton
                            name="Anuluj"
                            baseClass="custom-button-white mapen-modal-button"
                            onClick={handleClose}
                        />
                        <CustomButton
                            name={isSaving ? 'Zapisywanie...' : 'Zapisz zmiany'}
                            baseClass="custom-button-orange mapen-modal-button"
                            onClick={handleSave}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SettingsModal;
